import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import uniqBy from "lodash/uniqBy";
import "./XFDLDropdown.css";
import PropTypes from "prop-types";
/*istanbul ignore next */
const CustomPopper = React.forwardRef(function CustomPopper(props, ref) {
  const { dropdownWidth, placement, ...other } = props;
  return (
    <Popper
      {...other}
      ref={ref}
      style={{ width: dropdownWidth, zIndex: 1300 }}
      placement={placement}
    />
  );
});
/*istanbul ignore next */
export default function XFDLDropdown(props) {
  const {
    isEditMode,
    dropdownWidth = 300,
    dense = false,
    placement = "bottom-start",
    ...rest
  } = props;
  const index = props.index ? props.index : 0;

  return (
    <Autocomplete
      {...rest}
      PopperComponent={CustomPopper}
      slotProps={{
        popper: {
          dropdownWidth,
          placement,
        },
      }}
      clearIcon={props.clearIcon === "No" ? false : props.clearIcon}
      disablePortal={!props.multiple}
      multiple={props.multiple}
      options={props.options}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      ListboxProps={{
        style: {
          maxHeight: 150,
          padding: 0,
        },
      }}
      sx={{
        width: props.width,
        "& .MuiAutocomplete-listbox": {
          maxHeight: 180,
        },
      }}
      renderOption={(liProps, option) => (
        <li {...liProps} key={option.value}>
          {option.label}
        </li>
      )}
      value={!props.multiple && props.value ? props.value[0] : props.value}
      onChange={(event, newValue) => {
        let values =
          props.multiple && props.value
            ? uniqBy(newValue, (obj) => obj.id)
            : newValue;
        props.setData(values, index);
      }}
      disabled={props.disabled}
      filterSelectedOptions
      id={props.id}
      className={
        !isEditMode
          ? `disable-searchable-dropdown ${props.className} ${props?.classNameValue}`
          : `searchable-dropdown ${props.className}`
      }
      data-testid={props.id}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={props.placeholder}
          size={dense ? "small" : "medium"}
          error={props.error}
          InputProps={{
            ...params.InputProps,
            style: dense
              ? { paddingTop: 2, paddingBottom: 2, minHeight: "38px" }
              : {},
          }}
        />
      )}
    />
  );
}

XFDLDropdown.propTypes = {
  isEditMode: PropTypes.bool,
  dropdownWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dense: PropTypes.bool,
  placement: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,

  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      id: PropTypes.any,
    })
  ),
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  setData: PropTypes.func.isRequired,
  index: PropTypes.number,
  id: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  clearIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  classNameValue: PropTypes.string,
};

XFDLDropdown.defaultProps = {
  isEditMode: true,
  dropdownWidth: 300,
  dense: false,
  placement: "bottom-start",
  multiple: false,
  disabled: false,
  error: false,
  options: [],
  value: [],
  index: 0,
  id: "",
  width: 300,
  placeholder: "",
  clearIcon: undefined,
  className: "",
  classNameValue: "",
};

CustomPopper.propTypes = {
  dropdownWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placement: PropTypes.string,
};
